const isEmailChangeActionPath = (pathname: string) =>
  pathname === "/email-change/confirm" || pathname === "/email-change/revert";

let capturedToken: string | undefined;

if (isEmailChangeActionPath(window.location.pathname)) {
  capturedToken = window.location.hash.slice(1) || undefined;
  window.history.replaceState(null, "", window.location.pathname + window.location.search);
}

export const takeEmailChangeActionToken = () => {
  const token = capturedToken;
  capturedToken = undefined;
  return token;
};
